/**
 * Created by Christof Sander on 01.07.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	methods: {
		getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
			if(actionKey === 'tagPicker_tags'){
				let modelFieldIndex, fieldConfig;
				if(
					fieldCode &&
					(modelFieldIndex = ((this.model.fieldProperties || {})[fieldCode] || {}).modelFieldIndex) &&
					(fieldConfig = ((this.model.fields || [])[modelFieldIndex] || {}).config) &&
					fieldConfig.categoryEntityType === 'routes'
				){
					const routeID = ((this.resourceData.data || {}).attributes || {})[(this.resourceData.data || {}).primaryKey || 'id'] || 0;
					if(routeID){
						resourceFilters = resourceFilters || {};
						resourceFilters.routeID = routeID;
					}
				}
			}
			return resourceFilters;
		},

		onAttachDone: function(){
			this.config.useCase = this.config.useCase || ((this.resourceData && this.resourceData.data && this.resourceData.data.attributes && utils.isEmpty(this.resourceData.data.attributes.parentRouteID)) ? 'rootNode' : undefined);

			const $field = this.$.find('.field.fieldOf_langCode')
			if($field.length > 0){
				if(this.hasAccessTo('usage:languages:showRouteLanguageDetails')){
					const data = this.resourceData.data || {}
					const primaryKey = (data.attributes || {})[data.primaryKey || 'id']
					if(primaryKey){
						const routeDetails = ((this.resourceData.routeDetails || {}).data || {}).attributes || {}
						const langCode = this.getFieldValue('langCode', 'live') || 'NO_LANG'
						const inheritedLangCode = routeDetails.inheritedLangCode || 'NO_LANG'
						$field.append(`<label class="inline">langCode: ${langCode}, inheritedLangCode: <b>${inheritedLangCode}</b></label>`)

						if(this.config.useCase != 'rootNode'){
							$field.find('.toggleOption').addClass('disabled')
						}
					}
				} else if(this.config.useCase != 'rootNode'){
					$field.find('[data-field-code="langCode"]').attr('DISABLED', 'DISABLED')
					$field.hide();
				}
			}
		},

		onSubmit: function(response){
			this.refresh();
		},

		generateArticleName: function(additionalFields){
			additionalFields = additionalFields || {};

			var prefix = '';
			if(additionalFields.articleNr){
				prefix = `${additionalFields.articleNr || ''} - `
			}

			return `${prefix}${additionalFields.articleName || ''}`;
		},

		updateKeyDownLabelValue: function(fieldCode, fieldConfig, value) {
			var pathPart;

			if(this.config.useArticleMode){
				if(fieldCode === 'articleNr' || fieldCode === 'articleName') {
					var additionalFields = utils.replace(((this.resourceData.data || {}).attributes || {}).additionalFields || {}, (((this.model.dirtyFields || {}).data || {}).attributes || {}).additionalFields || {});
					additionalFields[fieldCode] = value;
					pathPart = utils.nameSeoToPath(this.generateArticleName(additionalFields));
				}
			} else {
				if(fieldCode === 'nameSEO'){
					pathPart = utils.nameSeoToPath(value || '');
				}
			}

			if(pathPart !== undefined){
				var path = ((this.resourceData.data || {}).attributes || {}).path || ''
				// path would not be correct in cases of a duplication to a targetRouteID
				if((((((this.model.dirtyFields || {}).data || {}).attributes || {}).duplicateMeta || {}).target || {}).routeID){
					path = ''
				}

				var parentPath = '';
				if(path) {
					parentPath = (String(path).trim('/').replace(/\/+[^\/]+$/g, '') || '') + '/';
				} else {
					parentPath = '.../';
				}

				var path = `${parentPath}${pathPart}`;
				this.triggerFind('updateKeyDownLabelValue', { value: path }, 'base_form_fields_text')

				return path;
			}

			return '';
		},

		onChange: function(isRelationChange, changeDone, fieldData){
			var updateTabTitle;
			var fieldCode = (fieldData || {}).fieldCode;
			var entityID = ''

			if(this.config.useArticleMode){
				if(fieldCode === 'articleNr' || fieldCode === 'articleName') {
					var attributes = ((this.resourceData || {}).data || {}).attributes || {}
					var additionalFields = utils.simpleMerge(attributes.additionalFields || {}, (((this.model.dirtyFields || {}).data || {}).attributes || {}).additionalFields || {});
					if(additionalFields) {
						entityID = attributes.routeID || attributes.id
						var name = this.generateArticleName(additionalFields);
						updateTabTitle = name;
						this.fieldToModel('name', name);
						this.fieldToModel('nameSEO', name);
					}
				}
			} else if(fieldCode === 'name') {
				updateTabTitle = (fieldData || {}).fieldValue;
			}

			if(updateTabTitle){
				var entityPrefix = '';
				if(entityID && this.hasRoleOption('showIDs')){
					entityPrefix = '#' + entityID + ' - ';
				}

				this.furthest('base_tabStrip_tabContent', undefined, function(tabContent){
					var registerSecret = (tabContent.config || {}).registerSecret;
					if(registerSecret !== undefined){
						tabContent.closest('base_tabStrip_tabStrip', function(tabStrip){
							tabStrip.refreshTab(registerSecret, {
								title: entityPrefix + updateTabTitle
							});
						});
					}
				});
			}
		},

		handleError: function(context){
			var self = this;
			var apiError = utils.extractBaseError(context.error) || {};

			if(apiError.statusCode === 409 && apiError.errorCode === 'SAVE_MBLX_PRODUCT_UNIQUE_ARTICLE_NUMBER_ERROR'){
				return self.performAction(
					self.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:upsert.mblxProducts.uniqueArticleNumberViolation'
						}
					})
				);
			}
			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		}
	},

	handlers: [
		{
			name: 'onDeleteRoute',
			componentClass: 'templates_routeTrees_routeTrees',
			handle: function(callerComponent, primaryKey){
				var data = this.resourceData.data || {};
				var attributes = data.attributes || {};
				if(primaryKey && attributes[data.primaryKey || 'id'] === primaryKey){
					this.furthest('base_tabStrip_tabContent', undefined, function(tabContent){
						tabContent.close(true);
					});
				}
			}
		},
		{
			name: 'onDeleteMBLXProduct',
			componentClass: 'templates_mblx_controller',
			handle: function(callerComponent, primaryKey){
				if(this.config.useArticleMode){
					var data = this.resourceData.data || {};
					var attributes = data.attributes || {};
					if(primaryKey && attributes[data.primaryKey || 'id'] === primaryKey){
						this.furthest('base_tabStrip_tabContent', undefined, function(tabContent){
							tabContent.close(true);
						});
					}
				}
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_routePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				// update langCode details if a potential parentRoute has been changed.
				if(!insertPerformed && this.hasAccessTo('usage:languages:showRouteLanguageDetails') && nodeData){
					const primaryKey = nodeData.data.attributes[nodeData.data.primaryKey];
					const data = this.resourceData.data || {};
					const attributes = data.attributes || {};
					if(!primaryKey || attributes[data.primaryKey || 'id'] !== primaryKey){
						this.refresh()
					}
				}
			}
		},
	]
};
